module.exports = __webpack_public_path__ + "static/img/YI-CHEN LIN.jpg";